import { gql } from "graphql-tag";
import GraphQLJSON, { GraphQLJSONObject } from "graphql-type-json";
export const typeDef = gql`
  directive @cacheControl(
    maxAge: Int
    scope: CacheControlScope
  ) on OBJECT | FIELD | FIELD_DEFINITION

  enum CacheControlScope {
    PUBLIC
    PRIVATE
  }

  scalar JSON
  scalar JSONObject

  type Genre {
    id: ID!
    name: String!
  }

  type PageInfo {
    offset: Int
    limit: Int
    totalCount: Int
    hasNextPage: Boolean
    hasPreviousPage: Boolean
  }
`;
export const resolvers = {
  JSON: GraphQLJSON,
  JSONObject: GraphQLJSONObject
};